import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PreOrderApi } from "api";

const preOrderApi = new PreOrderApi();

export const preOrderIban = createAsyncThunk(
  "preOrder/preOrderIban",
  async ({
    phoneNumber,
    source,
    onSuccess,
    onError,
  }: {
    phoneNumber: string;
    source: string;
    onSuccess?: () => void;
    onError?: () => void;
  }) => {
    try {
      await preOrderApi.apiPreOrderPost(phoneNumber, source);

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      if (onError) {
        onError();
      }
    }
  }
);

const preOrderSlice = createSlice({
  name: "preOrder",
  initialState: null,
  reducers: {},
});

export default preOrderSlice.reducer;
